import React, {useContext} from 'react';
import {FormContext} from './MDForm';
import {propsToCSS} from '../css';
import {BASIC_ELEMENT_SCHEMA, Group} from '../layout/Group';
import {merge} from 'lodash';
import {TooltipHint} from './TooltipHint';

const NO_TRACK = v => v;

export function Expression(props) {
  const formContext = useContext(FormContext);


  let missed = false;

  const track = !props.requireAll ? NO_TRACK : v => {
    if (!v) {
      missed = true;
    }
    return v;
  };

  const style = {
    fontStyle: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    marginBottom: '0'
  }

  const value = props.value
    .replace(/#{([^}]+)}/g, (_, attr) => track(formContext.getUIValueByAttr(attr))||'')
    .replace(/\${([^}]+)}/g, (_, path) => track(formContext.getValue(path))||'');

  if (missed) {
    return null;
  }
  const hintText = props.hintText;

  return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={style}>{value}
    {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
  </h1>;
}

Expression.schema = merge({
  properties: {
    value: {
      type: 'string',
    },
    requireAll: {
      type: 'boolean',
    },
  }
}, BASIC_ELEMENT_SCHEMA);